/* Outdoors Nordic. Flyttad ur snippets/on-cart-reco.liquid 2026-10-07.
   Lag inline och skickades med varje sidvisning som anvande sektionen.
   Laddas som modul: samma URL evalueras en gang oavsett antal taggar. */

  (function () {
if (customElements.get('on-cart-reco')) return;
function listOf(attr) { return (attr || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
function setOf(attr) { return new Set(listOf(attr)); }
class OnCartReco extends HTMLElement {
connectedCallback() {
this.list = this.querySelector('[data-cr-list]');
this.titleEl = this.querySelector('[data-cr-title]');
// Listan är skyddad med data-skip-subtree-update → korten överlever varukorgens morph.
// Har den redan kort (bevarade) rör vi dem inte; annars laddar vi.
if (this.list && this.list.querySelector('.on-cr__card')) {
  if (this.titleEl) this.titleEl.hidden = false;
  this.syncFallback();
} else {
  this.load();
}
// Säkerhet: om recon inte hunnit/kunnat rendera kort → visa bästsäljar-fallbacken ändå.
var selfCC = this;
setTimeout(function () { selfCC.syncFallback(); }, 1500);
// Rendera/visa NÄR drawern öppnas (elementet blir synligt) – fixar "dyker ibland inte upp"
// (async-hämtning + morph medan drawern var dold). Lätt IntersectionObserver, ingen MutationObserver.
if (!this._visIO && 'IntersectionObserver' in window) {
  this._visIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      if (selfCC.list && !selfCC.list.querySelector('.on-cr__card')) {
        if (window.__onCrPool) { selfCC.render(); } else { selfCC.load(); }
      }
      selfCC.syncFallback();
    });
  });
  this._visIO.observe(this);
}
// Vid varukorgs-ändring: KIRURGISK uppdatering (ta bort tillagd, fyll på en ny) – ingen blink.
if (!window.__onCrReco) {
  window.__onCrReco = true;
  document.addEventListener('cart:update', function (e) {
    // Skicka med FÄRSKA korg-varorna från eventet → reconcile slipper förlita
    // sig på data-ids-attributet (som morph kan hinna uppdatera för sent).
    var cart = e && e.detail && e.detail.resource;
    setTimeout(function () {
      var el = document.querySelector('on-cart-reco');
      if (el && typeof el.reconcile === 'function') el.reconcile(cart);
    }, 150);
  });
  // Drawern är en native <dialog>. Att ÖPPNA den fyrar inget cart:update men innehållet kan
  // om-renderas → korten wipe:as. Lätt observer på ENBART 'open'-attributet → rendera om från pool.
  var recoOnOpen = function () {
    var el = document.querySelector('on-cart-reco');
    if (!el || !el.list) return;
    if (!el.list.querySelector('.on-cr__card')) {
      if (window.__onCrPool && typeof el.render === 'function') { el.render(); }
      else if (typeof el.load === 'function') { el.load(); }
    }
    if (typeof el.syncFallback === 'function') el.syncFallback();
  };
  var bindRecoDlg = function () {
    document.querySelectorAll('.cart-drawer__dialog').forEach(function (dlg) {
      if (dlg.__onCrRecoObs || !('MutationObserver' in window)) return;
      dlg.__onCrRecoObs = true;
      new MutationObserver(function () { [40, 250, 700, 1400].forEach(function (t) { setTimeout(recoOnOpen, t); }); }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    });
  };
  bindRecoDlg();
  setTimeout(bindRecoDlg, 1000);
}
}
cartSets() {
return {
  ids: setOf(this.getAttribute('data-ids')),
  genders: setOf(this.getAttribute('data-genders')),
  seasons: setOf(this.getAttribute('data-seasons')),
  types: setOf(this.getAttribute('data-types')),
  limit: parseInt(this.getAttribute('data-limit') || '3', 10)
};
}
passes(it, s) {
if (!it.pid || s.ids.has(it.pid)) return false;
if (it.g.length && s.genders.size) {
  if (!(it.g.indexOf('unisex') > -1 || it.g.some(function (g) { return s.genders.has(g); }))) return false;
}
if (it.s.length && s.seasons.size) {
  if (!it.s.some(function (x) { return s.seasons.has(x); })) return false;
}
return true;
}
showFallback(show) {
var scope = this.closest('.on-fold__body') || this.parentNode;
var fb = scope ? scope.querySelector('[data-cr-fallback]') : null;
if (fb) fb.hidden = !show;
}
// Visa bästsäljar-fallbacken när recon inte har några kort (garanterar att upsellen ALLTID syns).
syncFallback() {
var has = !!(this.list && this.list.querySelector('.on-cr__card'));
this.showFallback(!has);
document.dispatchEvent(new CustomEvent('on-cart-reco:rendered', { bubbles: true }));
}
load() {
var self = this;
if (window.__onCrPool) { this.render(); return; }
var url = this.getAttribute('data-url') || '/recommendations/products';
var seed = this.getAttribute('data-seed');
var section = this.getAttribute('data-section') || 'on-cart-reco-section';
if (!seed) return;
var full = url + (url.indexOf('?') > -1 ? '&' : '?') + 'product_id=' + seed + '&limit=12&intent=related&section_id=' + section;
fetch(full, { headers: { Accept: 'text/html' } })
  .then(function (r) { return r.text(); })
  .then(function (html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var cards = Array.prototype.slice.call(tmp.querySelectorAll('.on-cr__card'));
    var pool = [];
    cards.forEach(function (c) {
      var pid = (c.getAttribute('data-pid') || '').trim();
      if (!pid) return;
      pool.push({
        pid: pid,
        g: listOf(c.getAttribute('data-g')),
        s: listOf(c.getAttribute('data-s')),
        t: (c.getAttribute('data-t') || '').trim(),
        html: c.outerHTML
      });
    });
    window.__onCrPool = pool;
    self.render();
  })
  .catch(function () { self.syncFallback(); });
}
render() {
var pool = window.__onCrPool;
if (!pool || !this.list) return;
var s = this.cartSets(), self = this;
var comp = [], rest = [], seen = {};
pool.forEach(function (it) {
  if (seen[it.pid] || !self.passes(it, s)) return;
  seen[it.pid] = 1;
  if (it.t && !s.types.has(it.t)) comp.push(it); else rest.push(it);
});
var ordered = comp.concat(rest).slice(0, s.limit);
this.list.innerHTML = ordered.map(function (o) { return o.html; }).join('');
if (this.titleEl) this.titleEl.hidden = ordered.length === 0;
this.syncFallback();
}
reconcile(cart) {
var pool = window.__onCrPool;
if (!pool || !this.list) { return; }
var s = this.cartSets(), self = this, byId = {};
// Bygg korg-ID från det färska cart-objektet om det finns (annars data-ids).
if (cart && cart.items && cart.items.length) {
  s.ids = new Set();
  cart.items.forEach(function (it) { if (it && it.product_id != null) s.ids.add(String(it.product_id)); });
}
pool.forEach(function (it) { byId[it.pid] = it; });
// 1. Ta bort kort som nu ligger i korgen (eller inte längre passar). Övriga rörs ej.
Array.prototype.slice.call(this.list.querySelectorAll('.on-cr__card')).forEach(function (c) {
  var pid = (c.getAttribute('data-pid') || '').trim();
  var it = byId[pid];
  if (s.ids.has(pid) || !it || !self.passes(it, s)) c.remove();
});
// 2. Fyll lediga platser med nya förslag (komplementär typ först), som inte redan visas.
var shown = Array.prototype.slice.call(this.list.querySelectorAll('.on-cr__card')).map(function (c) { return (c.getAttribute('data-pid') || '').trim(); });
if (shown.length < s.limit) {
  var comp = [], rest = [];
  pool.forEach(function (it) {
    if (shown.indexOf(it.pid) > -1 || !self.passes(it, s)) return;
    if (it.t && !s.types.has(it.t)) comp.push(it); else rest.push(it);
  });
  comp.concat(rest).forEach(function (it) {
    if (shown.indexOf(it.pid) > -1 || shown.length >= s.limit) return;
    self.list.insertAdjacentHTML('beforeend', it.html);
    shown.push(it.pid);
  });
}
if (this.titleEl) this.titleEl.hidden = shown.length === 0;
this.syncFallback();
}
}
customElements.define('on-cart-reco', OnCartReco);
  })();

